import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./index.css";

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import Aos from "aos";
import "aos/dist/aos.css"
import 'react-toastify/dist/ReactToastify.css';
import { isMobile } from 'react-device-detect';

import MainMaster from "./Components/Layouts/MainMaster";
import Home from "./Components/Home/Home";

import ScrollToTop from "./Components/ScrollToTop/ScrollToTop";
import Desktop from "./Components/Pages/Desktop/Desktop";
import PrivacyPolicy from "./Components/Pages/PrivacyPolicy/PrivacyPolicy";
import AboutUs from "./Components/Pages/AboutUs/AboutUs";
import Purpose from "./Components/Pages/Purpose/Purpose";
import Sustainability from "./Components/Pages/Sustainability/Sustainability";
import TermsofUse from "./Components/Pages/TermsofUse/TermsofUse";


function App() {

  useEffect(()=>{
    Aos.init({duration:1000});
    },[]);


  useEffect(()=>{
    if(isMobile){
      window.location.href = process.env.REACT_APP_MOBILE_FRONTEND;
    return null;
    }
    },[]);
  return (
    <>

    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<MainMaster />}>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={ <Desktop /> } />
          <Route path="/privacy/policy" element={ <PrivacyPolicy /> } />
          <Route path="/about/us" element={ <AboutUs /> } />
          <Route path="/who-we-are/our-purpose" element={ <Purpose /> } />
          <Route path="/who-we-are/sustainability-data--trading-insights3" element={ <Sustainability /> } />
          <Route path="/terms-of-use" element={ <TermsofUse /> } />
        </Route>
      </Routes>
    </BrowserRouter>
    
    </>
   
  );
}

export default App;
